import React, { InputHTMLAttributes } from 'react';
import { useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { FormWrapper, Label, InputCheck } from './styles';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TArgs = { [argName: string]: any };
export interface FormCheckProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  register: UseFormRegisterReturn;
}

const FormCheck: React.FC<FormCheckProps> = ({ label, name, register, ...props }) => {
  const [check, setCheck] = useState<boolean>(true);
  return (
    <FormWrapper>
      <Label htmlFor={name}>
        <InputCheck
          id={name}
          {...props}
          {...register}
          type="checkbox"
          checked={check}
          onChange={() => setCheck(!check)}
        />
        {label}
      </Label>
    </FormWrapper>
  );
};

export default FormCheck;
